module.exports = __webpack_public_path__ + "img/class_nodata.295dba38.png";